"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

// We support mostly Safari > 11, Promise.any is available since Safari 14
// Since polyfill is quite simple, decided to use it instead of Promise.any
// https://caniuse.com/mdn-javascript_builtins_promise_any
var any = function any(promisesArray) {
  var promiseErrors = new Array(promisesArray.length);
  var counter = 0; //return a new promise

  return new Promise(function (resolve, reject) {
    promisesArray.forEach(function (promise, index) {
      Promise.resolve(promise).then(resolve) // resolve, when any of the input promise resolves
      .catch(function (error) {
        promiseErrors[index] = error;
        counter = counter + 1;

        if (counter === promisesArray.length) {
          // all promises rejected, reject outer promise
          reject(promiseErrors);
        }
      }); // reject, when any of the input promise rejects
    });
  });
};

var _default = any;
exports.default = _default;
//# sourceMappingURL=promise-any-polyfill.js.map